import { render, staticRenderFns } from "./DangerZone.vue?vue&type=template&id=083305d6"
import script from "./DangerZone.vue?vue&type=script&lang=js"
export * from "./DangerZone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports